







import Vue from 'vue';
import i18n from 'vue-i18n';
import LegalAgreements from '@/components/Templates/User/Legal/LegalAgreements.vue';

// Keep localization available when this view is rendered outside the app.
Vue.use(i18n);

export default {
    name: 'PurchaseCancellationPolicy',
    components: {
        LegalAgreements,
    },
};
